import { c as _c } from "react-compiler-runtime";
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { shouldBypassContextMenu } from '../../contextMenu/shouldBypassContextMenu';
import { useMemo } from 'react';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { getCellExternalId } from '../utils/cellIdUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const Cell = t0 => {
  const $ = _c(38);
  const {
    CellComponent,
    columnIndex,
    rowIndex,
    columnNamespace,
    columnName,
    rowId,
    row,
    isCellVisible
  } = t0;
  let t1;
  if ($[0] !== columnName || $[1] !== columnNamespace || $[2] !== rowId) {
    t1 = getCellExternalId(columnNamespace, columnName, rowId);
    $[0] = columnName;
    $[1] = columnNamespace;
    $[2] = rowId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const externalId = t1;
  const contextMenuConfig = useFDTContextMenuConfig();
  const triggerContextMenu = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.triggerContextMenu;
  let t2;
  if ($[4] !== columnName || $[5] !== columnNamespace) {
    t2 = columnNamespace === CONTACT_TYPE_ID && ["name", "email"].includes(columnName) ? {
      "data-onboarding": `contact-${columnName}-cell`
    } : {};
    $[4] = columnName;
    $[5] = columnNamespace;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onboardingSelectors = t2;
  let t3;
  if ($[7] !== columnName || $[8] !== columnNamespace || $[9] !== row || $[10] !== triggerContextMenu) {
    t3 = triggerContextMenu ? e => {
      if (shouldBypassContextMenu(e)) {
        return;
      }
      const handled = triggerContextMenu({
        row,
        columnName,
        columnNamespace
      });
      if (handled === true) {
        e.preventDefault();
        e.stopPropagation();
      }
    } : undefined;
    $[7] = columnName;
    $[8] = columnNamespace;
    $[9] = row;
    $[10] = triggerContextMenu;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== columnIndex || $[13] !== externalId || $[14] !== onboardingSelectors || $[15] !== t3) {
    t4 = Object.assign({
      id: externalId,
      "data-table-external-id": externalId,
      "data-test-id": externalId,
      onContextMenu: t3
    }, onboardingSelectors, {
      "data-column-index": columnIndex
    });
    $[12] = columnIndex;
    $[13] = externalId;
    $[14] = onboardingSelectors;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const requiredCellProps = t4;
  if (!isCellVisible) {
    let t5;
    if ($[17] !== requiredCellProps) {
      t5 = /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps));
      $[17] = requiredCellProps;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  let t5;
  if ($[19] !== CellComponent || $[20] !== columnIndex || $[21] !== columnName || $[22] !== columnNamespace || $[23] !== requiredCellProps || $[24] !== row || $[25] !== rowIndex) {
    t5 = /*#__PURE__*/_jsx(CellComponent, {
      rowIndex: rowIndex,
      columnIndex: columnIndex,
      columnNamespace: columnNamespace,
      columnName: columnName,
      row: row,
      requiredCellProps: requiredCellProps
    });
    $[19] = CellComponent;
    $[20] = columnIndex;
    $[21] = columnName;
    $[22] = columnNamespace;
    $[23] = requiredCellProps;
    $[24] = row;
    $[25] = rowIndex;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  const cellElement = t5;
  const isContextMenuOpen = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.getIsContextMenuOpen({
    row,
    columnName,
    columnNamespace
  });
  if (contextMenuConfig !== null && contextMenuConfig !== void 0 && contextMenuConfig.ContextMenuContentComponent && isContextMenuOpen) {
    let t6;
    if ($[27] !== columnName || $[28] !== columnNamespace || $[29] !== contextMenuConfig.ContextMenuContentComponent || $[30] !== row) {
      t6 = /*#__PURE__*/_jsx(contextMenuConfig.ContextMenuContentComponent, {
        columnName: columnName,
        columnNamespace: columnNamespace,
        row: row
      });
      $[27] = columnName;
      $[28] = columnNamespace;
      $[29] = contextMenuConfig.ContextMenuContentComponent;
      $[30] = row;
      $[31] = t6;
    } else {
      t6 = $[31];
    }
    let t7;
    if ($[32] !== triggerContextMenu) {
      t7 = () => {
        triggerContextMenu === null || triggerContextMenu === void 0 || triggerContextMenu({
          columnName: null,
          columnNamespace: null,
          row: null
        });
      };
      $[32] = triggerContextMenu;
      $[33] = t7;
    } else {
      t7 = $[33];
    }
    let t8;
    if ($[34] !== cellElement || $[35] !== t6 || $[36] !== t7) {
      t8 = /*#__PURE__*/_jsx(Popover, {
        arrowSize: "small",
        closeOnOutsideClick: true,
        content: t6,
        "data-test-id": "context-menu-popover",
        onOpenChange: t7,
        open: true,
        placement: "bottom right",
        children: cellElement
      });
      $[34] = cellElement;
      $[35] = t6;
      $[36] = t7;
      $[37] = t8;
    } else {
      t8 = $[37];
    }
    return t8;
  }
  return cellElement;
};
export default Cell;